import i18n from '@/plugins/i18n'

export default {
    path: '/' + i18n.t('forget-password.routes.index'),
    name: 'forget-password',
    component: () =>
        import(
            /* webpackChunkName: "forget-password" */ '@/views/auth/ForgetPassword.vue'
        ),
    meta: {
        layout: 'simple-layout',
        guest: true,
    },
}
